import React from "react";
import { FaFacebookF } from "react-icons/fa";
import { useLanguage } from '../../context/LanguageContext';

const SassMarketingIntregation = () => {
  const { t } = useLanguage();

  const apps = [
        {
      id: 'quilmes',
      icon: 'assets/img/quilmes.png',
      alt: 'quilmes'
    },
     
    {
      id: 'gob',
      icon: 'assets/img/gob.png',
      alt: 'gobierno buenos aires'
    },
      {
      id: 'rightee',
      icon: 'assets/img/rightee.png',
      alt: 'rightee'
    },
       {
      id: 'grupovisco',
      icon: 'assets/img/grupovisco.png',
      alt: 'grupovisco'
    },
      {
      id: 'cardiohome',
      icon: 'assets/img/cardiohome.png',
      alt: 'cardiohome'
    },
   
    {
      id: 'enero',
      icon: 'assets/img/enero.png',
      alt: 'enero'
    },
       {
      id: 'tecnoedil',
      icon: 'assets/img/tecnoedil.png',
      alt: 'tecnoedil'
    },
  
       
       {
      id: 'youbeep',
      icon: 'assets/img/youbeep-2.png',
      alt: 'youbeep'
    },

  
    {
      id: 'xhockware',
      icon: 'assets/img/xhockware.png',
      alt: 'xhockware merlin'
    },
    

  ];

  return (
    <section className="mk-integration bg-white ptb-80">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <div className="mk-title text-center">
              <h2 className="mk-heading mb-0 mt-3">
                {t('integrations.title')}
              </h2>
            </div>
          </div>
        </div>
        <div className="mt-5">
          <div className="row justify-content-center g-4">
            {apps.map((app, index) => (
              <div className="col-xxl-3 col-xl-4 col-md-6" key={index}>
                <div className="mk-app-single d-flex align-items-center p-3">
                  <span className={`icon-wrapper d-inline-flex align-items-center justify-content-center flex-shrink-0 rounded ${app.id}`}>
                    <img
                      src={app.icon}
                      alt={app.alt}
                      className="img-fluid"
                    />
                  </span>
                  <div className="ms-3">
                    <h6 className="mk-heading mb-1">{t(`integrations.apps.${app.id}.name`)}</h6>
                    <p className="mb-0 fs-sm">
                      {t(`integrations.apps.${app.id}.description`)}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
          {/* <p className="text-center mb-0 mt-40">
            Do You Want to explore more{" "}
            <a href="#" className="text-mk-secondary fw-bold">
              Integration
            </a>
          </p> */}
        </div>
      </div>
    </section>
  );
};

export default SassMarketingIntregation;
